import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ModalBox from "../../../ui/ModalBox";
import { useNavigate, useParams } from "react-router-dom";
import FormService from "./FormService";
import { useService } from "../Provider";

const UpdateService = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [reload, setReload] = useState(false);

  const {
    state: { selected: service },
    fetchOne: fetchService,
  } = useService();
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  useEffect(() => {
    fetchService(id);
  }, [fetchService, id, reload]);
  const handleSuccess = () => {
    setOpen(true);
    setReload(!reload);
  };
  if (!service) return;
  if (service?.id != id) return;

  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Update Service
      </Typography>
      <FormService
        service={service}
        fixedType={true}
        handleSuccess={handleSuccess}
      />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.. You updated service"
      />
    </>
  );
};

export default UpdateService;
